/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';

export interface IPharmacyAccess {
  id?: string;
  uhid?: string | null;
  active?: boolean | null;
  revoked?: boolean | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  comboUser?: IPharmacy;
  glucoUser?: IGlucoUser;
}

export const defaultValue: Readonly<IPharmacyAccess> = {
  active: false,
  revoked: false,
};
